import { useNostr } from '@nostrify/react';
import { useQuery } from '@tanstack/react-query';
import type { NostrEvent } from '@nostrify/nostrify';

/** Hashtag variants — Nostr hashtag tags are matched as written, so cover common cases. */
const HASHTAGS = ['shesatsnairobi', 'SheSatsNairobi', 'SHESATSNAIROBI'];

export const RSVP_HASHTAG = 'shesatsnairobi';

/**
 * Fetches public "I'm in" notes — kind 1 events tagged #SheSatsNairobi —
 * deduplicated to one entry per author, newest first.
 */
export function useRsvps() {
  const { nostr } = useNostr();

  return useQuery({
    queryKey: ['shesats-rsvps'],
    queryFn: async (c) => {
      const events = await nostr.query(
        [{ kinds: [1], '#t': HASHTAGS, limit: 100 }],
        { signal: c.signal },
      );

      const byAuthor = new Map<string, NostrEvent>();
      for (const event of events) {
        const existing = byAuthor.get(event.pubkey);
        if (!existing || event.created_at > existing.created_at) {
          byAuthor.set(event.pubkey, event);
        }
      }

      return [...byAuthor.values()].sort((a, b) => b.created_at - a.created_at);
    },
  });
}
